import { ComponentPropsWithoutRef, FC } from 'react';
import styled from 'styled-components';
import { editorTheme } from '../../../theme';
import { ButtonStyleProps } from 'styled-system';

const StyledButton = styled.button`
  background: ${editorTheme.accent};
  border: none;
  border-radius: 8px;
  color: white;
  display: flex;
  height: 40px;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    background: ${editorTheme.accentHover};
  }
`;

const secondaryStyle = {
  backgroundColor: editorTheme.surfaceMuted,
  color: editorTheme.text,
  border: `1px solid ${editorTheme.border}`,
};

type ButtonProps = ComponentPropsWithoutRef<'button'> &
  ButtonStyleProps & {
    secondary?: boolean;
  };

const Button: FC<ButtonProps> = ({ secondary, style, ...props }) => (
  <StyledButton
    type="button"
    {...props}
    style={{ ...style, ...(secondary && secondaryStyle) }}
  />
);

export default Button;
